<template>
  <pt-branch-company-detail class="pt-branch-company-detail__withData"  :detail="detail"
  :detailLoading="detailLoading" :paymentLoading="paymentLoading" :paymentDetail="paymentDetail"
  @getOrganizationMerchant="getOrganizationMerchant" @getDetail="getDetail"></pt-branch-company-detail>
</template>

<script>
import PtBranchCompanyDetail from './index'
export default {
  name: 'pt-branch-company-detail__withData',
  components: {
    'pt-branch-company-detail': PtBranchCompanyDetail
  },
  data () {
    return {
      detail: {},
      paymentDetail: [],
      detailLoading: false,
      paymentLoading: false
    }
  },
  methods: {
    getDetail () {
      this.detailLoading = true
      this.$store.dispatch('getBranchCompanyDetail', this.$route.params.id).then(ret => {
        this.detailLoading = false
        let businessName = []
        if (ret.business) {
          ret.business.forEach(param => {
            businessName.push(param.name)
          })
        }
        ret.business = businessName.length ? businessName.toString() : '--'
        this.detail = ret
      }).catch(err => {
        this.detailLoading = false
        this.$message.error(err || '获取分/子公司详情失败')
      })
    },
    getOrganizationMerchant () {
      this.paymentLoading = true
      this.$store.dispatch('getOrganizationMerchant', this.$route.params.id).then(res => {
        this.paymentLoading = false
        this.paymentDetail = res
      }).catch(err => {
        this.paymentLoading = false
        this.$message.error(err || '获取分子公司字符信息失败')
      })
    }
  },
  created () {
  }

}
</script>
